/**
 * authorizerTokenCookie works for both forge & auth0 flow
 * It is named as auth0.user.token as all the microApps are expecting the token in this legacy cookie name
 */
export const authorizerTokenCookie = 'auth0.user.token';
export const teamIdCookie = 'teamId';
